export const getParksQuery = `query GetParks {
  getParks {
    facilities {
      ID
      address
      amenities
      attachments
      hours
      latlng
      notes
      title
      url
      zip
      isRental
      isAdopted
      isAdoptionEligable
      mappedAmenities
      type
      googlePlacesId
    }
  }
}`;

export const getLocationDetailsQuery = `query GetLocationDetails($locationName: String) {
  getLocationDetails(locationName: $locationName) {
    item {
      ID
      address
      amenities
      attachments
      hours
      latlng
      notes
      title
      url
      zip
      isRental
      isAdopted
      isAdoptionEligable
      mappedAmenities
      type
      googlePlacesId
      phoneNumber
    }
    messages
  }
}`;

export const getAmenitiesQuery = `query MyQuery {
  getParks {
    amenities {
      ID
      title
    }
  }
}`;

export const getLocationGoogleReviewQuery = `query GetLocationGoogleReview($placeId: String!) {
  getLocationGoogleReview(placeId: $placeId) {
    messages
    placeId
    placeDetails {
      rating
      url
      userRatingsTotal
      reviews {
        author
        authorPhoto
        rating
        relativeTime
        text
        time
      }
    }
  }
}`;
